import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Leaf } from 'lucide-react';
export function Hero() {
  return <Section bg="cream" className="pt-32 md:pt-40 pb-24" data-id="element-75">
      <div className="max-w-4xl mx-auto text-center space-y-8" data-id="element-76">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-sage-100 text-sage-800 font-medium text-sm mb-4" data-id="element-77">
          <Leaf size={16} data-id="element-78" />
          <span data-id="element-79">Guias-Salud</span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight tracking-tight" data-id="element-80">
          Deja de adivinar con tus suplementos y comienza a obtener{' '}
          <span className="text-sage-700 italic" data-id="element-81">resultados reales.</span>
        </h1>

        <h2 className="text-xl md:text-2xl text-charcoal-light font-sans max-w-3xl mx-auto leading-relaxed" data-id="element-82">
          La Guía Inteligente para saber qué tomar, a qué hora, cómo combinarlo
          y cómo elegir marcas de calidad superior sin tirar tu dinero.
        </h2>

        <div className="pt-8 pb-4" data-id="element-83">
          <Button href="#pricing" data-id="element-84">QUIERO MI GUÍA AHORA</Button>
        </div>

        <div className="bg-white p-8 rounded-2xl shadow-soft mt-12 text-left border border-sage-100 relative" data-id="element-85">
          <div className="absolute -top-4 -left-4 text-6xl text-sage-200 font-serif leading-none" data-id="element-86">
            "
          </div>
          <p className="text-lg text-charcoal leading-relaxed relative z-10 font-medium" data-id="element-87">
            ¿Alguna vez te has quedado frente a tu estante de suplementos a las
            11 de la noche preguntándote:{' '}
            <span className="italic text-sage-700" data-id="element-88">
              “¿Esto me lo debía tomar con la cena o antes de dormir?”
            </span>{' '}
            o peor aún,{' '}
            <span className="italic text-sage-700" data-id="element-89">
              “¿estaré tomando cosas que se anulan entre sí?”
            </span>
          </p>
          <p className="text-lg text-charcoal leading-relaxed mt-4 relative z-10" data-id="element-90">
            Si te sientes confundido por la avalancha de información en internet
            y no sabes si tu inversión en salud está funcionando o simplemente
            terminando en la orina, no estás solo.
          </p>
        </div>
      </div>
    </Section>;
}